export const NOTIFICATION_ACTION_TYPES = {
  HIDE: 'HIDE',
  PROCESS: 'PROCESS',
};
